import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import { TrainingSharedFacade } from '@medsurf/flat-facades';

/**
 * TODO's:
 * - Buttons can be simplified to only one
 */
@Component({
    selector: 'medsurf-quiz-question-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './question-footer.component.html',
    styleUrls: ['./question-footer.component.scss'],
    standalone: false
})
export class QuestionFooterComponent {
  /**
   * Inputs
   */
  @Input() public question: FlatModels.QuestionEntityModels.QuestionEntityType;
  @Input() public trainingResult: FlatModels.TrainingSharedModels.TrainingResultType;
  @Input() public showRequired: boolean;
  @Input() public isCorrect: () => boolean;
  @Input() public passRequired: () => boolean;

  /**
   * Outputs
   */
  @Output() showRequiredChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Constructor
   *
   * @param trainingSharedFacade
   */
  public constructor(public trainingSharedFacade: TrainingSharedFacade) {
  }

  /**
   * Set Show Feedback
   *
   * @param trainingPage
   */
  public setShowFeedback(trainingPage: FlatModels.PageEntityModels.Training | FlatModels.PageEntityModels.Slide) {
    if (this.passRequired()) {
      this.trainingSharedFacade.requestSetShowFeedback(this.trainingResult, (trainingPage.slideId || '').toString(), this.question, this.isCorrect())
    } else {
      this.showRequired = true;
      this.showRequiredChange.emit(this.showRequired);
    }
  }

  /**
   * Toggle Show Explanation
   */
  public toggleShowExplanation() {
    this.trainingSharedFacade.requestToggleShowExplanation(this.trainingResult);
  }
}
